import type { AppDefinition } from '../../types/apps';

export const MarkdownAppV2Definition: AppDefinition = {
  appId: 'markdown-v2',
  name: 'Markdown',
  version: '1.0.0',
  description: 'Simple markdown document editor',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'FileText',
    phosphorWeight: 'duotone',
  },
  entityIcons: {
    MarkdownDoc: {
      type: 'phosphor',
      phosphorIcon: 'FileText',
      phosphorWeight: 'duotone',
      color: '#10b981',
    },
  },
  entityTypes: ['MarkdownDoc'],
  component: 'markdown-v2',
  requiresProps: false,
  requiresEntity: true,
  actions: {},
  hidden: true,
};
